














import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GChatVideoMessage',
  props: {
    videoUrl: {
      type: String as PropType<string>,
    },
  },
  methods: {
    onClickUrl(): void {
      this.$emit('click-video', this.videoUrl);
    },
  },
});
